module.exports = __webpack_public_path__ + "img/lu.7f70b02c.svg";